const monetizationFeatures = [
  {
    icon: 'ri-advertisement-line',
    title: 'Publicidad Propia',
    description: 'Vendé tus propios espacios publicitarios: banners en tu web, menciones al aire, sorteos y eventos patrocinados. Vos ponés el precio, vos manejás la relación con el anunciante.',
    stat: '$12,700',
    statLabel: 'ingresos propios',
    tag: 'Gestión directa',
    color: 'emerald',
    link: '/sa/own-ads',
  },
  {
    icon: 'ri-global-line',
    title: 'Red Publicitaria RFW',
    description: 'Conectate a la red de pauta programática de RFW y recibí anuncios de marcas nacionales e internacionales. Activá ingresos pasivos sin mover un dedo.',
    stat: '9',
    statLabel: 'radios activas',
    tag: 'Pauta programática',
    color: 'amber',
    link: '/sa/ad-network',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Marketplace',
    description: 'Anunciantes publican sus necesidades y vos les enviás propuestas. Un mercado abierto donde las radios compiten por campañas. La plataforma conecta, vos cerrás el trato.',
    stat: '12',
    statLabel: 'anunciantes activos',
    tag: 'Oferta y demanda',
    color: 'orange',
    link: '/sa/ad-marketplace',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Patrocinadores',
    description: 'Conseguí sponsors para tus programas, segmentos y eventos. Marcas que confían en tu audiencia y pagan por estar presentes. Desde el negocio local hasta la multinacional.',
    stat: '$1.53M',
    statLabel: 'inversión total',
    tag: 'Relaciones comerciales',
    color: 'teal',
    link: '/sa/sponsors',
  },
  {
    icon: 'ri-pie-chart-2-line',
    title: 'Revenue Share',
    description: 'Modelo ganar-ganar: la radio se lleva el 70% de cada campaña y RFW el 30%. Transparencia total con métricas en tiempo real de impresiones, clicks y engagement.',
    stat: '$270K',
    statLabel: 'ganancias radios',
    tag: '70/30 split',
    color: 'rose',
    link: '/sa/revenue-share',
  },
];

const colorMap: Record<string, { bg: string; border: string; iconBg: string; iconColor: string; statColor: string; tagBg: string; tagColor: string; glow: string }> = {
  emerald: { bg: 'from-emerald-500/10 to-emerald-500/5', border: 'border-emerald-500/20 hover:border-emerald-500/40', iconBg: 'bg-emerald-500/10', iconColor: 'text-emerald-600', statColor: 'text-emerald-700', tagBg: 'bg-emerald-500/10', tagColor: 'text-emerald-700', glow: 'bg-emerald-500/5' },
  amber:   { bg: 'from-amber-500/10 to-amber-500/5', border: 'border-amber-500/20 hover:border-amber-500/40', iconBg: 'bg-amber-500/10', iconColor: 'text-amber-600', statColor: 'text-amber-700', tagBg: 'bg-amber-500/10', tagColor: 'text-amber-700', glow: 'bg-amber-500/5' },
  orange:  { bg: 'from-orange-500/10 to-orange-500/5', border: 'border-orange-500/20 hover:border-orange-500/40', iconBg: 'bg-orange-500/10', iconColor: 'text-orange-600', statColor: 'text-orange-700', tagBg: 'bg-orange-500/10', tagColor: 'text-orange-700', glow: 'bg-orange-500/5' },
  teal:    { bg: 'from-teal-500/10 to-teal-500/5', border: 'border-teal-500/20 hover:border-teal-500/40', iconBg: 'bg-teal-500/10', iconColor: 'text-teal-600', statColor: 'text-teal-700', tagBg: 'bg-teal-500/10', tagColor: 'text-teal-700', glow: 'bg-teal-500/5' },
  rose:    { bg: 'from-rose-500/10 to-rose-500/5', border: 'border-rose-500/20 hover:border-rose-500/40', iconBg: 'bg-rose-500/10', iconColor: 'text-rose-600', statColor: 'text-rose-700', tagBg: 'bg-rose-500/10', tagColor: 'text-rose-700', glow: 'bg-rose-500/5' },
};

export default function MonetizacionSection() {
  return (
    <section id="monetizacion" className="relative py-20 md:py-28 overflow-hidden bg-background-50">
      {/* Ambient glows */}
      <div className="absolute top-0 left-0 w-[450px] h-[450px] bg-emerald-500/4 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-amber-500/3 rounded-full blur-3xl pointer-events-none"></div>

      {/* Dot grid */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.02]" style={{
        backgroundImage: 'radial-gradient(circle, currentColor 1px, transparent 1px)',
        backgroundSize: '20px 20px',
      }}></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        {/* ── Header ── */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold mb-5">
            <i className="ri-money-dollar-circle-line text-xs"></i>
            Monetización
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Convierte tu audiencia{' '}
            <span className="text-emerald-600">en ingresos</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            RFW te da todas las herramientas para que tu radio genere dinero. Desde vender tus propios espacios hasta conectarte con la red publicitaria más grande de radio online.
          </p>
        </div>

        {/* ── 5 feature cards: 3 + 2 ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-4">
          {monetizationFeatures.slice(0, 3).map((feature) => {
            const c = colorMap[feature.color];
            return (
              <a
                key={feature.title}
                href={feature.link}
                className={`group relative rounded-2xl border ${c.border} bg-gradient-to-br ${c.bg} p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl cursor-pointer`}
              >
                {/* Top row: icon + stat */}
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${c.iconBg} ${c.iconColor} transition-all duration-300 group-hover:scale-110`}>
                    <i className={`${feature.icon} text-lg`}></i>
                  </div>
                  <div className="text-right">
                    <div className={`text-xl md:text-2xl font-extrabold ${c.statColor} tabular-nums leading-tight`}>
                      {feature.stat}
                    </div>
                    <div className="text-foreground-400 text-[10px] font-medium whitespace-nowrap">{feature.statLabel}</div>
                  </div>
                </div>

                {/* Title + tag */}
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-foreground-950 font-bold text-sm md:text-base">{feature.title}</h3>
                  <span className={`text-[10px] font-semibold ${c.tagColor} ${c.tagBg} px-2 py-0.5 rounded-full whitespace-nowrap`}>
                    {feature.tag}
                  </span>
                </div>

                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4">{feature.description}</p>

                {/* Arrow */}
                <div className={`flex items-center gap-1.5 ${c.iconColor} text-xs font-semibold transition-all duration-300 group-hover:gap-2.5`}>
                  <span>Explorar</span>
                  <i className="ri-arrow-right-line text-xs transition-transform duration-300 group-hover:translate-x-0.5"></i>
                </div>

                {/* Corner accent glow */}
                <div className={`absolute -bottom-6 -right-6 w-24 h-24 ${c.glow} rounded-full blur-2xl pointer-events-none`}></div>
              </a>
            );
          })}
        </div>

        {/* Second row: 2 cards centered */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-3xl mx-auto">
          {monetizationFeatures.slice(3, 5).map((feature) => {
            const c = colorMap[feature.color];
            return (
              <a
                key={feature.title}
                href={feature.link}
                className={`group relative rounded-2xl border ${c.border} bg-gradient-to-br ${c.bg} p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl cursor-pointer`}
              >
                {/* Top row: icon + stat */}
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${c.iconBg} ${c.iconColor} transition-all duration-300 group-hover:scale-110`}>
                    <i className={`${feature.icon} text-lg`}></i>
                  </div>
                  <div className="text-right">
                    <div className={`text-xl md:text-2xl font-extrabold ${c.statColor} tabular-nums leading-tight`}>
                      {feature.stat}
                    </div>
                    <div className="text-foreground-400 text-[10px] font-medium whitespace-nowrap">{feature.statLabel}</div>
                  </div>
                </div>

                {/* Title + tag */}
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-foreground-950 font-bold text-sm md:text-base">{feature.title}</h3>
                  <span className={`text-[10px] font-semibold ${c.tagColor} ${c.tagBg} px-2 py-0.5 rounded-full whitespace-nowrap`}>
                    {feature.tag}
                  </span>
                </div>

                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4">{feature.description}</p>

                {/* Arrow */}
                <div className={`flex items-center gap-1.5 ${c.iconColor} text-xs font-semibold transition-all duration-300 group-hover:gap-2.5`}>
                  <span>Explorar</span>
                  <i className="ri-arrow-right-line text-xs transition-transform duration-300 group-hover:translate-x-0.5"></i>
                </div>

                {/* Corner accent glow */}
                <div className={`absolute -bottom-6 -right-6 w-24 h-24 ${c.glow} rounded-full blur-2xl pointer-events-none`}></div>
              </a>
            );
          })}
        </div>

        {/* ── Bottom trust strip ── */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 text-center">
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-shield-check-line text-emerald-500"></i>
            <span>Panel de métricas en tiempo real</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-foreground-300"></div>
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-bank-line text-amber-500"></i>
            <span>Pagos automatizados mensuales</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-foreground-300"></div>
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-file-chart-line text-teal-500"></i>
            <span>Reportes descargables para tus anunciantes</span>
          </div>
        </div>
      </div>
    </section>
  );
}